import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Service Worker registrieren + automatisch updaten
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const swUrl = `/sw.js?v=${__APP_BUILD_ID__}`;
      const reg = await navigator.serviceWorker.register(swUrl, {
        updateViaCache: 'none',
      });
      // Bei jedem Seitenaufruf auf Updates prüfen
      reg.update();
      // Wenn ein neuer SW wartet, sofort aktivieren
      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Neuer SW installiert → sofort aktivieren
              newWorker.postMessage('SKIP_WAITING');
            }
          });
        }
      });
      // Wenn der aktive SW wechselt, Seite neu laden für frische Assets
      // Beim ersten Besuch hat noch kein SW die Kontrolle -> kein Reload
      let refreshing = false;
      let hadController = !!navigator.serviceWorker.controller;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing && hadController) {
          refreshing = true;
          window.location.reload();
        }
        hadController = true;
      });
    } catch {
      // SW nicht unterstützt
    }
  });
}

const root = document.getElementById("root")!;
createRoot(root).render(<App />);
// Remove FOUC guard after React has painted
requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add("hydrated")));
